module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.9e6484e0.png";